<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品分类">
      <template>
        <el-button
          icon="el-icon-plus"
          size="small"
          type="primary"
          @click="newlyAdded"
          >新增商品分类</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 0
                  ? 'iconfont icon-lock'
                  : 'iconfont icon-jihuo'
              "
            ></i
            >{{ row.row.status == 0 ? "禁用" : "启用" }}
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 启用
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  itemClassGetList,
  itemClassDel,
  itemClassActive,
  itemClassLock,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "productClassification",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        height: "calc(100vh - 270px)",
        loading: false,
        search: [
          {
            label: "分类名称",
            type: "input",
            key: "name",
          },
        ],
        data: [],
        column: [
          {
            label: "分类ID",
            prop: "id",
          },
          {
            label: "分类名称",
            prop: "name",
          },
          {
            label: "父分类",
            prop: "parent_name",
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
          {
            label: "排序",
            prop: "sort_order",
            sortable: true,
          },
        ],
        isPage: false,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 禁用方法
    locking(row) {
      this.$confirm("是否确认禁用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemClassLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 启用方法
    activation(row) {
      this.$confirm("是否确认启用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemClassActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemClassDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      itemClassGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = this.$findChildren(0, res.data);
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/productClassification/index.vue